import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

// Components
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";

import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import BugReportIcon from '@mui/icons-material/BugReport';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import LanguageIcon from '@mui/icons-material/Language';
import api from "../../utils/axios";
import { APP_VERSION, DEFAULT_RELEASE_NOTES } from "../../config/appVersion";

function Home() {
  const navigate = useNavigate();
  const [releaseNotesOpen, setReleaseNotesOpen] = useState(false);
  const [releaseNotesValue, setReleaseNotesValue] = useState("");

  useEffect(() => {
    const loadReleaseNotes = async () => {
      try {
        const empId = localStorage.getItem("emp_id");
        const [notesRes, seenRes] = await Promise.all([
          api.get("/release-notes", { params: { version: APP_VERSION } }),
          api.get("/release-notes/seen", {
            params: { version: APP_VERSION, emp_id: empId },
          }),
        ]);
        if (seenRes.data?.seen) {
          return;
        }
        setReleaseNotesValue(notesRes.data?.result?.Notes ?? DEFAULT_RELEASE_NOTES);
        setReleaseNotesOpen(true);
      } catch (error) {
        setReleaseNotesValue(DEFAULT_RELEASE_NOTES);
        setReleaseNotesOpen(true);
      }
    };
    loadReleaseNotes();
  }, []);

  const handleCloseReleaseNotes = async () => {
    const empId = localStorage.getItem("emp_id");
    try {
      await api.post("/release-notes/seen", {
        Version: APP_VERSION,
        Emp_Id: empId,
      });
    } catch (error) {
      // fallback: close dialog even if logging fails
    }
    setReleaseNotesOpen(false);
  };
  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      <Topbar breadcrumbs={[{ label: 'หน้าหลัก' }]} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: 'var(--sidebar-width, 220px)',
          mt: '56px',
          p: { xs: 2, md: 4 },
          background: (theme) => theme.palette.background.default,
          minHeight: 'calc(100vh - 56px)'
        }}
      >
        <Dialog open={releaseNotesOpen} onClose={handleCloseReleaseNotes} fullWidth maxWidth="sm">
          <DialogTitle>อัปเดตเวอร์ชัน {APP_VERSION}</DialogTitle>
          <DialogContent dividers>
            {releaseNotesValue.trim() ? (
              <Typography component="pre" sx={{ whiteSpace: "pre-wrap", fontFamily: "inherit" }}>
                {releaseNotesValue}
              </Typography>
            ) : (
              <Typography color="text.secondary">
                ยังไม่มีรายละเอียดการอัปเดต
              </Typography>
            )}
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button variant="contained" onClick={handleCloseReleaseNotes}>
              ปิด
            </Button>
          </DialogActions>
        </Dialog>

        <Grid container spacing={3} alignItems="center" sx={{ mt: 1 }}>
          <Grid item xs={12} md={7}>
            <Paper elevation={2} sx={{ p: { xs: 2, md: 4 } }}>
              <Typography
                variant="h3"
                component="h1"
                sx={{ fontWeight: 800, letterSpacing: '-1px' }}
              >
                THE BEST
                <br />
                SOLUTION
              </Typography>

              <Typography variant="subtitle1" sx={{ mt: 1, color: 'text.secondary' }}>
                บริการกำจัดแมลงและสัตว์รบกวนแบบมืออาชีพ ครอบคลุมพื้นที่ภาคใต้และพื้นที่ใกล้เคียง
              </Typography>

              <Grid container spacing={2} sx={{ mt: 3 }}>
                <Grid item xs={12} md={7}>
                  <List dense>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleOutlineIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText primary="กำจัดปลวก มด แมลงสาบ และหนู" />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleOutlineIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText primary="ตรวจประเมินและให้คำแนะนำเชิงป้องกัน" />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleOutlineIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText primary="บริการสำหรับบ้าน อาคาร และโรงงาน" />
                    </ListItem>
                  </List>
                </Grid>

                <Grid item xs={12} md={5} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<BugReportIcon />}
                    sx={{ mr: 2 }}
                    onClick={() => navigate('/sale')}
                  >
                    สร้างลูกค้า / ใบเสนอราคา
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="large"
                    onClick={() => navigate('/sale-customer-calendar')}
                  >
                    ดูบริการทั้งหมด
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Right visual / card */}
          <Grid item xs={12} md={5}>
            <Box sx={{ position: 'relative' }}>
              <Paper
                elevation={6}
                sx={{
                  p: 3,
                  height: { xs: 'auto', md: 320 },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  background: 'linear-gradient(135deg,#ff8a00 0%, #ff5e62 100%)',
                  color: '#fff'
                }}
              >
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    ShieldTech
                  </Typography>
                  <Typography sx={{ opacity: 0.95 }}>Pest Control Services</Typography>
                </Box>

                <Box sx={{ mt: 1 }}>
                  <Typography variant="h4" sx={{ fontWeight: 800 }}>
                    7 สาขา ทั่วภาคใต้
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PhoneIcon />
                    <Typography sx={{ fontWeight: 700 }}>076 610 066</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LanguageIcon />
                    <Typography>www.shieldtech.co.th</Typography>
                  </Box>
                </Box>
              </Paper>

              {/* decorative circle */}
              <Box
                sx={{
                  position: 'absolute',
                  right: -40,
                  top: -30,
                  width: 140,
                  height: 140,
                  borderRadius: '50%',
                  background: 'rgba(0,0,0,0.06)'
                }}
              />
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 4 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="h6">บริการที่เชื่อถือได้</Typography>
                <Typography sx={{ color: 'text.secondary', mt: 1 }}>
                  ทีมงานมืออาชีพ ใช้วิธีตามมาตรฐานความปลอดภัย
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="h6">ครอบคลุมพื้นที่</Typography>
                <Typography sx={{ color: 'text.secondary', mt: 1 }}>
                  ภูเก็ต กระบี่ สุราษฎร์ธานี เกาะสมุย และพื้นที่ใกล้เคียง
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="h6">การันตีผลงาน</Typography>
                <Typography sx={{ color: 'text.secondary', mt: 1 }}>
                  บริการหลังการขาย และคำแนะนำเชิงป้องกันระยะยาว
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Paper sx={{ p: { xs: 2, md: 4 } }} elevation={1}>
            <Typography variant="h4" sx={{ fontWeight: 800 }}>
              เกี่ยวกับเรา
            </Typography>

            <Box sx={{ mt: 2 }}>
              <Typography sx={{ color: 'text.secondary', whiteSpace: 'pre-line' }}>
                บริษัท ชิลด์เทค เซอร์วิส (ประเทศไทย) จำกัด ได้รับอนุญาตให้ดำเนินกิจการ
                กำจัดแมลงและสัตว์รบกวน ตั้งแต่ปี พ.ศ. 2554 ก่อตั้งโดยคณะผู้บริหาร ที่มี
                ประสบการณ์ด้านงานยาวนาน ด้านงานบริการก่อน และหลังการขาย ประสบการณ์
                การทำงานมากกว่า 10 ปี ทำให้เรามีความชำนาญการทำงานบริการกำจัดปลวกและสัตว์
                รบกวนเพียงความรู้เบื้องต้นเพียงอย่างเดียว ไม่เพียงพอต้องมีการบริหารและ
                จัดการที่ดีในทุกๆด้าน
              </Typography>

              <Typography sx={{ mt: 2, fontWeight: 700 }}>
                บริษัท ชิลด์เทค "เรามุ่งมั่น ทำทุกอย่าง ให้คุณวางใจ" ปัจจุบันบริษัทฯเปิดให้บริการ 7 สาขา
              </Typography>

              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={12} md={6}>
                  <List dense>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleOutlineIcon />
                      </ListItemIcon>
                      <ListItemText primary="สาขาภูเก็ต ถนนบายพาส — 076 610 066, 088 765 5431 — info@shieldtech.co.th" />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleOutlineIcon />
                      </ListItemIcon>
                      <ListItemText primary="สาขากระบี่ สี่แยกคลองรีสหาด — 075 656584, 061 175 2229 — info@shieldtech.co.th" />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleOutlineIcon />
                      </ListItemIcon>
                      <ListItemText primary="สาขาสุราษฎร์ธานี สี่แยกท่าแพ — 077 270 877, 063 494 1944 — info@shieldtech.co.th" />
                    </ListItem>
                  </List>
                </Grid>

                <Grid item xs={12} md={6}>
                  <List dense>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleOutlineIcon />
                      </ListItemIcon>
                      <ListItemText primary="สาขาหาดใหญ่-สงขลา สี่แยกโคกเมา — 074 221 155, 061 825 5642 — info@shieldtech.co.th" />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleOutlineIcon />
                      </ListItemIcon>
                      <ListItemText primary="สาขานครศรีธรรมราช ถนนอ้อมค่าย — 075 450 440, 063 494 1943 — info@shieldtech.co.th" />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleOutlineIcon />
                      </ListItemIcon>
                      <ListItemText primary="สาขาชุมพร หน้าทางออก แยกโคกสก — 077 630 266, 082 757 0266 — info@shieldtech.co.th" />
                    </ListItem>
                  </List>
                </Grid>
              </Grid>

              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  หากต้องการข้อมูลเพิ่มเติม กรุณาติดต่อ: 076 610 066 | info@shieldtech.co.th
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Box>

      </Box>
    </Box>
  );
}

export default Home;
